<template>
  <NuxtLayout name="self-service" :page="page">
    <div class="w-96 flex flex-col gap-y-4 m-auto max-mobile:w-full">
      <main class="grow max-w-[800px] flex flex-col gap-4">
        <UtilsHeadline :level="2" :text="$t('dbc-text-forgot-password')" />
        <Card :pt="formCardPassThrough">
          <template #content>
            <FormKit
              :actions="false"
              type="form"
              form-class="rounded-lg"
              @submit="submit"
              #default="{ disabled, state: { valid } }"
              aria-errormessage="errorBanner"
              :aria-invalid="errorMessage"
            >
              <DbcBanner
                v-if="errorMessage"
                id="errorBanner"
                :severity="'warn'"
                :message="errorMessage"
              />

              <div>
                <p>{{ $t('dbc-reset-pw-text') }}</p>
              </div>

              <FormKit
                type="email"
                id="email"
                name="email"
                :label="$t('dbc-label-email')"
                :placeholder="$t('dbc-placeholder-email')"
                validation="required|email"
                prefix-icon="emailIcon"
                :floating-label="true"
                autocomplete="email"
              />

              <div class="flex flex-col gap-2xs">
                <FormKit
                  type="submit"
                  id="submit"
                  :label="
                    !valid
                      ? $t('dbc-text-fill-in-mandatory-field')
                      : $t('dbc-btn-request-link')
                  "
                  :disabled="disabled || !valid || isLoading"
                  :loading="isLoading"
                  :aria-label="
                    !valid
                      ? $t('dbc-text-fill-in-mandatory-field')
                      : !isLoading
                      ? $t('dbc-btn-request-link')
                      : $t('dbc-text-loading')
                  "
                />
                <FormKit
                  type="button"
                  id="abort"
                  @click="
                    router.push({
                      path: getPagePath['login']![locale],
                    })
                  "
                  :label="$t('dbc-btn-abort')"
                />
              </div>
            </FormKit>
          </template>
        </Card>
      </main>
    </div>
  </NuxtLayout>
</template>
<script setup lang="ts">
import { useCustomerStore } from '../../stores/customer'

const route = useRoute()
const router = useRouter()

const { t, setLocale } = useI18n()
const locale = route.params.locale as string
setLocale(locale)

const errorMessage = ref('')
const isLoading = ref(false)

async function submit(formData: { email: string }) {
  isLoading.value = true
  try {
    const { status } = await useFetchPasswordResetStart(formData)
    if (status === 200) {
      useCustomerStore().resetPwEmail = formData.email
      router.push({
        path: getPagePath['login']![locale],
        query: { 'pw-reset-start': '✓' },
      })
    }
  } catch {
    errorMessage.value = t('dbc-error-server-issues')
    isLoading.value = false
  }
}

const page: Page = {
  id: 0,
  title: t('dbc-text-forgot-password'),
  path: '/passwort-vergessen',
  description: '',
  content: [],
  localizations: [
    {
      id: 0,
      title: t('dbc-text-forgot-password'),
      path: 'passwort-vergessen',
      locale: 'de',
    },
    {
      id: 1,
      title: t('dbc-text-forgot-password'),
      path: 'forgot-password',
      locale: 'en',
    },
  ],
  locale: locale,
}
usePageHead(page)
</script>
